import Api from './api';

// ---------------------------------------------------------------------------
// Limite de requisições por contratante (API 2DO, api/security/rate-limit). JSON da API todo em minúsculo: normalizar aqui.
// Só o administrador global da Mexx (id 1): o servidor devolve canedit = false para qualquer outro e a tela não mostra o bloco.
// As exceções vão e voltam em LISTA (endpoint é valor): o nome "Api.Entidade.Metodo" mantém maiúsculas/minúsculas.
// Catálogo (apis): endpoints com limite de cada API do cliente; a 2DO busca na hora nas outras APIs (catalog = botão recarregar).
// Sem async/await em arrow (babel do react-scripts 4): Promise chain.
// ---------------------------------------------------------------------------

function unwrap(result) {
  const body = result && result.data;
  if (!body || body.success === false) {
    const msg = body && body.errors && body.errors[0];
    throw new Error(msg || 'Falha ao consultar o limite de requisições.');
  }
  return body;
}

const normalizeOverride = (o) => ({
  endpoint: o?.endpoint ?? '',
  maxRequests: Number(o?.maxrequests ?? 0),
  windowSeconds: Number(o?.windowseconds ?? 0),
  ipMaxRequests: o?.ipmaxrequests ?? null,
});

export const normalizeRateLimitApis = (apis) => (apis || []).map((a) => ({
  api: a?.api ?? '',
  ok: a?.ok === true,
  error: a?.error ?? null,
  endpoints: (a?.endpoints || []).map((e) => ({
    endpoint: e?.endpoint ?? '',
    name: e?.name ?? '',
    defaultMaxRequests: Number(e?.defaultmaxrequests ?? 0),
    defaultWindowSeconds: Number(e?.defaultwindowseconds ?? 0),
    anonymous: !!e?.anonymous,
    method: e?.method ?? '',
    route: e?.route ?? '',
  })),
}));

export const normalizeRateLimitSettings = (d) => ({
  canEdit: !!d?.canedit,
  overrides: (d?.overrides || []).map(normalizeOverride),
  apis: normalizeRateLimitApis(d?.apis),
  apiLabels: d?.apilabels || ['2Do', 'CalledService', 'Reports', '2Talk'],
  limits: {
    maxRequests: Number(d?.limits?.maxrequests ?? 100000),
    maxWindowSeconds: Number(d?.limits?.maxwindowseconds ?? 86400),
    maxOverrides: Number(d?.limits?.maxoverrides ?? 100),
    anonymousCeiling: Number(d?.limits?.anonymousceiling ?? 10),
  },
  cacheSeconds: Number(d?.cacheseconds ?? 60),
  readError: d?.readerror ?? null,
});

const toBody = (overrides) => ({
  overrides: (overrides || []).map((o) => ({
    endpoint: String(o.endpoint || '').trim(),
    maxRequests: Number(o.maxRequests) || 0,
    windowSeconds: Number(o.windowSeconds) || 0,
    ipMaxRequests: o.ipMaxRequests === null || o.ipMaxRequests === undefined || o.ipMaxRequests === '' ? null : Number(o.ipMaxRequests),
  })),
});

const RateLimitSettingsService = {
  settings: () => Api.get('/security/rate-limit/settings').then((r) => normalizeRateLimitSettings(unwrap(r).data || {})),
  catalog: () => Api.get('/security/rate-limit/catalog').then((r) => normalizeRateLimitApis((unwrap(r).data || {}).apis)),
  saveSettings: (overrides) => Api.put('/security/rate-limit/settings', toBody(overrides)).then((r) => normalizeRateLimitSettings(unwrap(r).data || {})),
};

export default RateLimitSettingsService;
